/**
 * The silent sign-in could not produce a token (typically an expired Okta session), so the only
 * recovery is sending the user through the interactive sign-in — not an error page.
 */
export class ReAuthenticationRequiredError extends Error {
	constructor(message: string) {
		super(message);
		this.name = 'ReAuthenticationRequiredError';
	}
}
